import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadExpertiseList = createAsyncThunk(
    'api/expertise_list',
    async () => await api.staticResources.getExpertiseList()
);
